import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Card, Accordion, ListGroup, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/student-services/complaints.webp";

const PaymentProcedure = () => {
  return (
    <React.Fragment>
      <title>Secure Payments – ISBM University | Easy Fee Guidelines</title>
      <meta
        name="description"
        content="Learn about the payment procedure at ISBM University. Get step-by-step guidelines for secure and hassle-free transactions. Visit Now"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Payment Procedure Guidelines</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Payment Procedure Guidelines
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>


      {/* Payment Content */}
      <section className="payment-content ptb-50">
        <div className="container-xxl">
          <Row >
            <Col lg={12}>
              <Card className="border-0 shadow mb-5">
                <Card.Body className="p-4">
                  <p className="text-blue  fs-5">
                    ISBM University has multiple options available for efficient and secured fee payment for students.
                    Details regarding the different modes of fee payment for students are given below.
                  </p>
                </Card.Body>
              </Card>

              {/* Payment Modes */}
              <div className="payment-modes mb-5">
                <h2 className="modern-title section-title-start text-blue">
                  <i className="ti ti-credit-card me-2"></i>
                  Fees Payment Mode
                </h2>
                <p className="mb-4">
                  Fees can be paid in either of the following modes:
                </p>

                <Row className="g-4">
                  <Col md={6} lg={4}>
                    <Card className="h-100 common-card">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-cash fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">Cash</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6} lg={4}>
                    <Card className="h-100 common-card">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-file-invoice fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">Cheque/Demand Draft</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6} lg={4}>
                    <Card className="h-100 common-card">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-credit-card fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">Credit Card</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6} lg={4}>
                    <Card className="h-100 common-card">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-building-bank fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">Online Bank Transfer</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6} lg={4}>
                    <Card className="h-100 common-card">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-credit-card-off fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">Online Credit Card Transfer</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6} lg={4}>
                    <Card className="h-100 common-card bg-blue text-white">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-click fs-1 text-white"></i>
                        </div>
                        <Card.Title>
                          <a href="/pay-fees-online" target="_blank" className="text-white stretched-link">
                            Click here to make payment
                          </a>
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <p className="mt-4">
                  Please get in touch at <a href="mailto:admissions@isbmuniversity.edu.in" target="_blank" className="text-purple">admissions@isbmuniversity.edu.in</a> for further details
                </p>
              </div>

              {/* Important Information */}
              <div className="important-info">
                <h2 className="modern-title section-title-start text-blue">
                  <i className="ti ti-alert-circle me-2"></i>
                  Other Related Important Information
                </h2>

                <ListGroup variant="flush">
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">1</Badge>
                    <span>You can opt for more than one course at a time.</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">2</Badge>
                    <span>Fees are subject to revision at any time.</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">3</Badge>
                    <span>Course once selected will not be changed under any circumstance.</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">4</Badge>
                    <span>You can change the course while taking admission or the same day of admission till the working hours.</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">5</Badge>
                    <span>Full fees has to be paid at the time of admission.</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">6</Badge>
                    <span>Fees once paid is not refundable under any circumstance.</span>
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default PaymentProcedure;
